module.exports = __webpack_public_path__ + "img/spain-flag.f3180900.png";